import SlimbarSkeletonLoader from './AppsListLoader'
export default SlimbarSkeletonLoader
